import { PortalApiError } from "../api/client";

export function portalAuthErrorMessage(error: unknown, fallback: string) {
	if (!(error instanceof PortalApiError) || error.code !== "portalRateLimited") return fallback;
	const seconds = Number.isFinite(error.retryAfterSeconds) ? Math.max(1, error.retryAfterSeconds ?? 1) : undefined;
	if (!seconds) return "Too many passkey attempts were made from this network. Wait a few minutes, then try again.";
	const minutes = Math.max(1, Math.ceil(seconds / 60));
	return `Too many passkey attempts were made from this network. Try again in about ${minutes} ${minutes === 1 ? "minute" : "minutes"}.`;
}
